export default class Menu {
	constructor() {
		this.id =  null;
		this.nome =  '';
		this.menuPai =  null;
		this.menuFilhos = [];
		this.permissoes =  [];		
		this.temFilhos =  false;
		this.ativo = true;
		this.publicado = false;
	}    
}